export default "__VITE_ASSET__DYZ9oNQV__"